"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustLanguage = exports.getCurrencyLocale = void 0;
const tslib_1 = require("tslib");
const i18next_1 = (0, tslib_1.__importDefault)(require("i18next"));
const i18next_locize_backend_1 = (0, tslib_1.__importDefault)(require("i18next-locize-backend"));
const moment = (0, tslib_1.__importStar)(require("moment"));
const index_1 = (0, tslib_1.__importDefault)(require("./fallbacks/index"));
const isTestMode = () => process.env.JEST_WORKER_ID !== undefined;
const projectId = '5db2e21c-6ee6-4335-a005-820ef78e85fe';
const fallbackLng = 'en';
const DefaultNamespaces = Object.keys(index_1.default.en);
const DefaultLanguages = Object.keys(index_1.default).filter((s) => typeof s === 'string');
if (!i18next_1.default.isInitialized) {
    i18next_1.default.use(i18next_locize_backend_1.default).init(Object.assign(Object.assign({ fallbackLng, defaultNS: 'Default', ns: DefaultNamespaces, interpolation: {
            escapeValue: false,
        }, partialBundledLanguages: true, load: 'languageOnly', resources: index_1.default }, (!isTestMode()
        ? {
            backend: {
                referenceLng: fallbackLng,
                projectId,
            },
        }
        : {})), { preload: DefaultLanguages }));
}
let currencyLoc = 'sv-SE';
moment.locale(global.navigator.language);
const getCurrencyLocale = () => currencyLoc;
exports.getCurrencyLocale = getCurrencyLocale;
const adjustLanguage = (language, currencyLocale) => (0, tslib_1.__awaiter)(void 0, void 0, void 0, function* () {
    if (i18next_1.default.language !== language) {
        i18next_1.default.changeLanguage(language);
    }
    currencyLoc = currencyLocale || language;
});
exports.adjustLanguage = adjustLanguage;
exports.default = i18next_1.default;
